import { EventEmitter, Injectable, Output } from '@angular/core';
import { ProcessCellForExportParams} from 'ag-grid-community';
import 'ag-grid-enterprise';
import { GenericLoaderData } from '../../shared/models/generic-loader.model';
import { OFFICE_CODES } from '../../shared/constants/office-codes.constants';

@Injectable({
    providedIn: 'root'
})
export class CopyPasteExportService {
    @Output() public showHideLoaderEmit = new EventEmitter<GenericLoaderData>();

    public getCellValueForClipboard(params: ProcessCellForExportParams, isExportToExcel = false): string {
        if (!params || !params.column || !params.column['colDef']) {
            return '';
        }
        const colDef = params.column['colDef'];
        if (
            (params.column.getInstanceId && params.column.getInstanceId() === 0) ||
            colDef.headerCheckboxSelection ||
            colDef.checkboxSelection
        ) {
            return '';
        }
        if (colDef.headerName && colDef.headerName.toLowerCase() === 'view') {
            return 'false';
        }
        const allowedFields = ['client','salesforceAccountId','opportunityOwner','Office','expiryDate','wording' ];
        const field = colDef.field;
        if (!field || !allowedFields.includes(field))  
            return '';
        if (!params.node?.data) 
            return params.value !== undefined && params.value !== null ? params.value.toString() : '';
        if (field.toLowerCase() === 'office') {
            const officeCode = params.node.data.officeCode;
            const office = OFFICE_CODES.find((o: any) => o.offCode === officeCode);
            return office ? office.offName : '';
        }
        if (field === 'opportunityOwner') {
            return params.node.data.opportunityOwnerName || params.node.data.opportunityOwner || '';
        }
        const value = params.node.data[field];
        return value !== undefined && value !== null ? value.toString() : '';
    }

    public showHideLoader(showUIBlock: boolean, showUIBlockMessage: string) {
        const genericLoaderdata = new GenericLoaderData();
        genericLoaderdata.showLoader = showUIBlock;
        genericLoaderdata.loaderMessage = showUIBlockMessage;
        this.showHideLoaderEmit.emit(genericLoaderdata);
    }
}
